
import "/data/action/_work/croco-manage-front/croco-manage-front/src/components/CustomTable/index.module.less?modules";
export default {"fillBody": `fillBody-OdPHxjZA`}
